import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public isLoading :BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public fileProgress = new BehaviorSubject<number>(0);
  fileProgress$ = this.fileProgress.asObservable();

  private exportErrorSubject = new BehaviorSubject<boolean>(false);
  exportError$ = this.exportErrorSubject.asObservable();

  private queue: any[] = [];
  public exportQueue$ = new BehaviorSubject<any[]>([]);
  private isExporting = false;

  firstInterval: any;
  secondInterval: any;

  constructor() { }


  getProgressValue(): number {
    return this.fileProgress.getValue(); // Assuming `fileProgress` is a BehaviorSubject
  }


  clearSecondInterval() {
    clearInterval(this.secondInterval)
  }

  showExportError() {
    this.exportErrorSubject.next(true);
  }

  hideError() {
    this.exportErrorSubject.next(false);
  }

  addToQueue(task: { name: string, fn: () => Promise<void> }) {
    this.queue.push(task);
    this.exportQueue$.next([...this.queue.map(q => ({ name: q.name }))]); // Only emit name to UI
    this.processQueue();
  }

  private async processQueue() {
    if (this.isExporting || this.queue.length === 0) return;

    this.isExporting = true;
    const task = this.queue.shift(); // task: { name, fn }
    this.exportQueue$.next([...this.queue.map(q => ({ name: q.name }))]);

    try {
      await task.fn(); // run the export function
    } catch (error) {
      this.showExportError();
    } finally {
      this.isExporting = false;
      setTimeout(() => {
        this.processQueue();
      }, 5000); // Simulate some delay before processing the next item

    }
  }

  startProgress(target?: number): void {
    let progress = this.fileProgress.getValue();
    console.log(progress);
    let intervalId: any;
    let isComplete = false;  // Track completion to prevent updates

    // Clear any previous intervals to prevent overlapping progress simulations
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }

    if (progress <= 1) {
      progress = Math.floor(Math.random() * 5) + 1;
      this.fileProgress.next(progress);
    }

    // If already at 100 or marked as complete, exit early
    if (progress === 100 || isComplete) {
      console.log("Already at 100, no further progress will be made.");
      return; // Exit if the progress is already 100 or complete
    }

    // Handle smooth progression towards 100 if target is 100
    if (target === 100) {
      this.firstInterval = setInterval(() => {
        if (progress < 100) {
          // Increment by small random steps (2-5)
          progress += Math.floor(Math.random() * 5) + 2;
          progress = Math.min(progress, 100); // Cap at 100

          this.fileProgress.next(progress); // Emit updated progress
        } else {
          console.log("Reached 100, stopping.");
          clearInterval(this.firstInterval); // Stop once 100 is reached
          isComplete = true; // Set the flag to prevent further updates
        }
      }, 100); // Updates every 100ms for smooth transition

    } else {
      // Simulate random progress up to a max stop point (70-95)
      const maxStopPoint = Math.floor(Math.random() * 25) + 80;

      this.secondInterval = setInterval(() => {
        if (progress < maxStopPoint) {
          progress += Math.floor(Math.random() * 5) + 1;
          progress = Math.min(progress, maxStopPoint);

          this.fileProgress.next(progress);
        } else {
          clearInterval(this.secondInterval);
        }
      }, 2000);
    }
  }

}
